<template>
    <div class="d-flex flex-column flex-fill">
        <div class="flex-fill">
            <p class="installment" v-text="$ml.get('installmentsExplanationV2')" tabindex="0" />
            <CieloSelectV2
                @change="selectItem"
                :title="$ml.get('installment')"
                :label="$ml.get('installmentsNumber')"
                :option-items="installmentList"
                :selected-item="numberOfInstallments"
                :on-get-item-event="getLangOptions"
                :disabled="this.installmentIsFixed"
            />
        </div>

        <div class="cta-container">
            <ButtonsNextPreviousV2
                :disable-button-next="!this.numberOfInstallments"
                @click-next="goToNextPage"
                @click-previous="goToPreviousStep"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Token, Options } from '@/config/lang/genericOptions.js';
import ButtonsNextPreviousV2 from '@/components/template/ButtonsNextPreviousV2.vue';
import CieloSelectV2 from '@/components/ClickToPay/template/CieloSelectV2/CieloSelectV2.vue';
import { logEvent } from '@/helpers/cieloLogger';

export default {
  components: {
    ButtonsNextPreviousV2,
    CieloSelectV2
  },

  computed: {
    ...mapGetters({
      installmentList: 'payment/getInstallmentListForPaymentMethodSelected',
      installmentIsFixed: 'payment/getSelectedPaymentMethodInstallmentIsAbleToBeFixed'
    }),
    numberOfInstallments: {
      get: (self) =>
        self.$store.getters['payment/getInstallmentNumberOfPayments'],
      set(value) {
        this.$store.commit('payment/setNumberOfInstallments', value);
      },
    },
  },

  data() {
    return {
      itemSelected: false,
    };
  },

  methods: {
    goToNextPage() {

		logEvent({

			category: 'checkout',
			action: 'forma_pagamento_qr-code_credito',
			label: 'Usuário escolhe a forma de pagamento qr-code e escolhe a quantidade de parcelas'

		});

      this.$store.dispatch('pipelineV2/pushNext');
      return;
    },

    goToPreviousStep() {
      this.$store.commit('payment/setNumberOfInstallments', 0);
      this.$store.dispatch('pipelineV2/pushPrevious');
    },

    selectItem(item) {
      this.numberOfInstallments = item;
    },

    getLangOptions(item) {
      let tokens = [];

      tokens.push(new Token('quantity', item.Value));
      tokens.push(new Token('installmentPrice', item.installmentPrice));

      return new Options('installmentsItem', tokens);
    },
  },
};
</script>
<style scoped>
.installment {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

  .cta-container {
      margin-top: 20px;
  }
</style>
